<template>
  <nuxt-link
    v-if="isPromo"
    id="promo-banner"
    :to="to"
    :class="['promo-banner', { show: isPromo }]"
    @click="sendYa"
  >
    <picture class="image picture">
      <source
        class="image"
        type="image/jpeg"
        :srcset="`/static/images/promo/promo-banner-summer-2025/768x40x1.jpg 1x, /images/promo/promo-banner-summer-2025/768x40x2.jpg 2x, /images/promo/promo-banner-summer-2025/768x40x3.jpg 3x`"
        media="(max-width: 767px)"
      />
      <source
        class="image"
        type="image/webp"
        :srcset="`/static/images/promo/promo-banner-summer-2025/768x40x1.webp 1x, /images/promo/promo-banner-summer-2025/768x40x2.webp 2x, /images/promo/promo-banner-summer-2025/768x40x3.webp 3x`"
        media="(max-width: 767px)"
      />
      <source
        class="image"
        type="image/webp"
        :srcset="`/static/images/promo/promo-banner-summer-2025/2560x60x1.webp 1x, /images/promo/promo-banner-summer-2025/2560x60x2.webp 2x, /images/promo/promo-banner-summer-2025/2560x60x3.webp 3x`"
      />
      <source
        class="image"
        type="image/jpeg"
        :srcset="`/static/images/promo/promo-banner-summer-2025/2560x60x1.jpg 1x, /images/promo/promo-banner-summer-2025/2560x60x2.jpg 2x, /images/promo/promo-banner-summer-2025/2560x60x3.jpg 3x`"
      />
      <img
        class="image"
        src="/static/images/promo/promo-banner-summer-2025/2560x60x3.jpg"
        alt="promo"
      />
    </picture>
  </nuxt-link>
</template>

<script lang="ts" setup>
defineProps({
  to: {
    type: String,
    required: true,
  },
});

const { $ymAnyEvent } = useNuxtApp();
const route = useRoute();
const isPromo = computed(() => {
  return !route.fullPath.includes('/promo/');
});
const sendYa = () => {
  $ymAnyEvent('reachGoal', 'promo-2023-top-banner-click');
};
const setPromoBanner = () => {
  const promoHeight =
    document?.getElementById('promo-banner')?.clientHeight || 0;
  document.documentElement.style.setProperty(
    '--promobannerheight',
    isPromo.value ? promoHeight + 'px' : '0px'
  );
};
onMounted(() => {
  window.addEventListener('resize', setPromoBanner);
  setPromoBanner();
});
watch(
  () => isPromo.value,
  () => {
    setTimeout(setPromoBanner, 100);
  }
);
</script>

<style scoped lang="scss">
.promo-banner {
  width: 100%;
  height: 0;
  cursor: pointer;
  display: block;
  &.show {
    height: 40px;
    @include md-block {
      height: 60px;
    }
  }

  .image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
  .picture {
    display: block;
  }
}
</style>
